import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=51a1dbcc&scoped=true"
import script from "./fotter.vue?vue&type=script&lang=js"
export * from "./fotter.vue?vue&type=script&lang=js"
import style0 from "./fotter.vue?vue&type=style&index=0&id=51a1dbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1dbcc",
  null
  
)

export default component.exports